import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { http, errorText, imgSrc } from "@/lib/api";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await http.post("/admin/uploads", fd);
  return data?.url || "";
}

export const ImagePicker = ({ onPicked, label, testId, className = "" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onPicked(await uploadImage(file));
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} className={`inline-flex items-center gap-2 border border-[#D8CFBC] bg-white px-4 py-2.5 text-[13px] text-[#16302B] hover:border-[#B8874A] transition-colors disabled:opacity-60 ${className}`} data-testid={testId}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" strokeWidth={1.5} />}
        {busy ? "Uploading…" : label}
      </button>
    </>
  );
};

export const CoverField = ({ value, onChange }) => (
  <div data-testid="post-cover-field">
    {value ? (
      <div className="relative aspect-[21/9] overflow-hidden border border-[#D8CFBC] bg-[#EFE9DC]">
        <img src={imgSrc(value)} alt="Cover" className="absolute inset-0 h-full w-full object-cover" data-testid="post-cover-preview" />
        <button type="button" onClick={() => onChange("")} className="absolute top-3 right-3 bg-white/90 p-2 text-[#16302B] hover:bg-white" aria-label="Remove cover" data-testid="post-cover-remove-button">
          <X className="h-4 w-4" />
        </button>
        <ImagePicker onPicked={onChange} label="Replace" testId="post-cover-replace-button" className="absolute bottom-3 right-3" />
      </div>
    ) : (
      <ImagePicker onPicked={onChange} label="Upload cover image" testId="post-cover-upload-button" />
    )}
  </div>
);
